// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-paint-brush:before {
  content: '\\f1fc';
  color: #36f;
  font-size: 20px;
}

.theme {
  margin-left: 7px;
  color: #36f;
  font-size: 20px;
}

.theme_body::before {
  content: '\\f1fc';
  font-family: FontAwesome;
  color: #36f;
  font-size: 15px;
  position: relative;
  top: 1.7rem;
  z-index: 10;
}

.language_body::before {
  content: '\\f1ab';
  font-family: FontAwesome;
  color: #36f;
  font-size: 15px;
  position: relative;
  top: 1.7rem;
  z-index: 10;
}

.biometric_body::before {
  content: '\\f132';
  font-family: FontAwesome;
  color: #36f;
  font-size: 15px;
  position: relative;
  top: 1.7rem;
  z-index: 10;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: bold;
  margin-top: 15px;
  margin-left: 6px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 25px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.4s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.slider:before {
  position: absolute;
  content: '';
  height: 17px;
  width: 17px;
  left: 8px;
  bottom: 4px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #36f;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.theme_container {
  display: flex;
  flex-wrap: wrap;
}

.theme_container .form-check {
  flex: 0 0 calc(33.333% - 1rem);
  white-space: nowrap;
}

.radioGrp .form-check {
  margin-right: 10px;
}

.offBiometric {
  color: #514e4e;
  font-weight: bold;
}

.onBiometric {
  color: #228b22;
  font-weight: bold;
}

@media (max-width: 768px) {
  .theme_container .form-check {
    flex: 0 0 50%;
  }

  .theme_container .form-check-input {
    margin-right: 0.2rem;
  }
}

@media (min-width: 768px) and (max-width: 1024.98px) {
  .theme_container .form-check {
    flex: 0 0 calc(33.333% + 0rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/system-settings/system-settings.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".fa-paint-brush:before {\n  content: '\\f1fc';\n  color: #36f;\n  font-size: 20px;\n}\n\n.theme {\n  margin-left: 7px;\n  color: #36f;\n  font-size: 20px;\n}\n\n.theme_body::before {\n  content: '\\f1fc';\n  font-family: FontAwesome;\n  color: #36f;\n  font-size: 15px;\n  position: relative;\n  top: 1.7rem;\n  z-index: 10;\n}\n\n.language_body::before {\n  content: '\\f1ab';\n  font-family: FontAwesome;\n  color: #36f;\n  font-size: 15px;\n  position: relative;\n  top: 1.7rem;\n  z-index: 10;\n}\n\n.biometric_body::before {\n  content: '\\f132';\n  font-family: FontAwesome;\n  color: #36f;\n  font-size: 15px;\n  position: relative;\n  top: 1.7rem;\n  z-index: 10;\n}\n\n.switch-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  margin-top: 15px;\n  margin-left: 6px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 25px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  border-radius: 34px;\n  transition: 0.4s;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.slider:before {\n  position: absolute;\n  content: '';\n  height: 17px;\n  width: 17px;\n  left: 8px;\n  bottom: 4px;\n  background-color: white;\n  border-radius: 50%;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background-color: #36f;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.theme_container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.theme_container .form-check {\n  flex: 0 0 calc(33.333% - 1rem);\n  white-space: nowrap;\n}\n\n.radioGrp .form-check {\n  margin-right: 10px;\n}\n\n.offBiometric {\n  color: #514e4e;\n  font-weight: bold;\n}\n\n.onBiometric {\n  color: #228b22;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .theme_container .form-check {\n    flex: 0 0 50%;\n  }\n\n  .theme_container .form-check-input {\n    margin-right: 0.2rem;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024.98px) {\n  .theme_container .form-check {\n    flex: 0 0 calc(33.333% + 0rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
